<template>
    <!-- <div class="card">
        <div class="row">
            <div class="col-md-8 offset-md-2">
                <h1>Privacy and Legal</h1>

                <h3>General</h3>
                <p>Please read these Terms carefully before using this Website. By accessing, browsing, or using this Website, you acknowledge that you have read, understood, and agree to be bound by these Terms of Use. If you do not accept these Terms of Use, do not use the Website. </p>
        
                <p>The author may modify all or any part of these Terms of Use, and the products and services mentioned in this Website, at any time, at its sole discretion, without notice to you. You should check back often so you are aware of your current rights and responsibilities. Your continued use of this Website after changes to the Terms of Use have been published constitutes your binding acceptance of the updated Terms of Use. If at any time the Terms of Use are no longer acceptable to you, you should immediately cease all use of this Website.</p>
                    
                <p>The author reserves the right to seek all remedies available by law and in equity for any violation of these terms and conditions. Any rights not expressly granted herein are reserved.</p>
        
                <h3>Trademarks</h3>
                <p>The trademarks, logos and service marks ("Marks") displayed on this Website are the property of the author or other third parties. You are not permitted to use these Marks without the prior written consent of the author or such third party which may own the Mark.</p>
        
                <h3>Copyrights</h3>
                <p>The information on this Website is protected by copyright, the terms of which must be observed and followed. This site and all content in this site may not be copied, reproduced, republished, uploaded, posted, transmitted, distributed, or used for the creation of derivative works without the author's prior written consent, except that the author grants you non-exclusive, non-transferable, limited permission to access and display the Web pages within this site, solely on your computer and for your personal, non-commercial use of this Website. This permission is conditioned on your not modifying the content displayed on this site, your keeping intact all copyright, trademark, and other proprietary notices, and your acceptance of any terms, conditions, and notices accompanying the content or otherwise set forth in this site. Notwithstanding the foregoing, any software and other materials that are made available for downloading, access, or other use from this site with their own license terms, conditions, and notices will be governed by such terms, conditions, and notices.</p>
        
                <p>Your failure to comply with the terms, conditions, and notices on this site will result in automatic termination of any rights granted to you, without prior notice, and you must immediately destroy all copies of downloaded materials in your possession or control. Except for the limited permission in the preceding paragraph, the author does not grant you any express or implied rights or licenses under any patents, trademarks, copyrights, or other proprietary or intellectual property rights. You may not mirror any of the content from this site on another website or in any other media.</p>
        
                <h3>Certain disclaimers</h3>
                <p>Information on this Website is not promised or guaranteed to be correct, current, or complete, and this site may contain technical inaccuracies or typographical errors. The author assumes no responsibility (and expressly disclaims responsibility) for updating this site to keep information current or to ensure the accuracy or completeness of any posted information. Accordingly, you should confirm the accuracy and completeness of all posted information before making any decision related to any services, products, or other matters described in this site.</p>
        
                <p>The author provides no assurances that any reported problems will be resolved by the author, even if the author elects to provide information with the goal of addressing a problem.</p>
        
                <h3>Confidential information</h3>
                <p>The author does not want to receive confidential or proprietary information from you through our Website. Please note that any information or material sent to the author will be deemed NOT to be confidential. By sending the author any information or material, you grant the author an unrestricted, irrevocable license to copy, reproduce, publish, upload, post, transmit, distribute, publicly display, perform, modify, create derivative works from, and otherwise freely use, those materials or information. You also agree that the author is free to use any ideas, concepts, know-how, or techniques that you send us for any purpose. However, we will not release your name or otherwise publicize the fact that you submitted materials or other information to us unless: (a) we obtain your permission to use your name; or (b) we first notify you that the materials or other information you submit to a particular part of this site will be published or otherwise used with your name on it; or (c) we are required to do so by law. Personally-identifiable information that you submit to the author for the purpose of receiving products or services will be handled in accordance with our privacy policies. Please see the section of this Website entitled "Privacy" for information regarding the author's privacy policies.</p>
        
                

                
            </div>
        </div>
    </div> -->
    <div class="flex-container">
        <div class="card">
    <div class="page">
        <div class="header">
            <div class="container">
                <p class="title">Privacy Policy for E-Nagarik</p>
            </div>
        </div>
        <div class="translations-content-container">
            <div class="container">
                <div class="tab-content translations-content-item en visible" id="en">
                    <h1>Privacy Policy</h1>
                    <p>Last updated: November 29, 2023</p>
                    <p>This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of
                        Your information when You use the Service and tells You about Your privacy rights and how the law
                        protects You.</p>
                    <p>We use Your Personal data to provide and improve the Service. By using the Service, You agree to the
                        collection and use of information in accordance with this Privacy Policy.</p>
                    <h2>Interpretation and Definitions</h2>
                    <h3>Interpretation</h3>
                    <p>The words of which the initial letter is capitalized have meanings defined under the following
                        conditions. The following definitions shall have the same meaning regardless of whether they appear
                        in singular or in plural.</p>
                    <h3>Definitions</h3>
                    <p>For the purposes of this Privacy Policy:</p>
                    <ul>
                        <li>
                            <p><strong>Account</strong> means a unique account created for You to access our Service or
                                parts of our Service.</p>
                        </li>
                        <li>
                            <p><strong>Affiliate</strong> means an entity that controls, is controlled by or is under common
                                control with a party, where "control" means ownership of 50% or more of the shares, equity
                                interest or other securities entitled to vote for election of directors or other managing
                                authority.</p>
                        </li>
                        <li>
                            <p><strong>Application</strong> refers to E-Nagarik, the software program provided by the
                                Company.</p>
                        </li>
                        <li>
                            <p><strong>Company</strong> (referred to as either "the Company", "We", "Us" or "Our" in this
                                Agreement) refers to E-Nagarik.</p>
                        </li>
                        <li>
                            <p><strong>Country</strong> refers to: Maharashtra, India</p>
                        </li>
                        <li>
                            <p><strong>Device</strong> means any device that can access the Service such as a computer, a
                                cellphone or a digital tablet.</p>
                        </li>
                        <li>
                            <p><strong>Personal Data</strong> is any information that relates to an identified or
                                identifiable individual.</p>
                        </li>
                        <li>
                            <p><strong>Service</strong> refers to the Application.</p>
                        </li>
                        <li>
                            <p><strong>Service Provider</strong> means any natural or legal person who processes the data on
                                behalf of the Company. It refers to third-party companies or individuals employed by the
                                Company to facilitate the Service, to provide the Service on behalf of the Company, to
                                perform services related to the Service or to assist the Company in analyzing how the
                                Service is used.</p>
                        </li>
                        <li>
                            <p><strong>Usage Data</strong> refers to data collected automatically, either generated by the
                                use of the Service or from the Service infrastructure itself (for example, the duration of a
                                page visit).</p>
                        </li>
                        <li>
                            <p><strong>You</strong> means the individual accessing or using the Service, or the company, or
                                other legal entity on behalf of which such individual is accessing or using the Service, as
                                applicable.</p>
                        </li>
                    </ul>
                    <h2>Collecting and Using Your Personal Data</h2>
                    <h3>Types of Data Collected</h3>
                    <h4>Personal Data</h4>
                    <p>While using Our Service, We may ask You to provide Us with certain personally identifiable
                        information that can be used to contact or identify You. Personally identifiable information may
                        include, but is not limited to:</p>
                    <ul>
                        <li>
                            <p>Email address</p>
                        </li>
                        <li>
                            <p>First name and last name</p>
                        </li>
                        <li>
                            <p>Phone number</p>
                        </li>
                        <li>
                            <p>Address, State, Province, ZIP/Postal code, City</p>
                        </li>
                        <li>
                            <p>Usage Data</p>
                        </li>
                    </ul>
                    <h4>Usage Data</h4>
                    <p>Usage Data is collected automatically when using the Service.</p>
                    <p>Usage Data may include information such as Your Device's Internet Protocol address (e.g. IP address),
                        browser type, browser version, the pages of our Service that You visit, the time and date of Your
                        visit, the time spent on those pages, unique device identifiers and other diagnostic data.</p>
                    <p>When You access the Service by or through a mobile device, We may collect certain information
                        automatically, including, but not limited to, the type of mobile device You use, Your mobile device
                        unique ID, the IP address of Your mobile device, Your mobile operating system, the type of mobile
                        Internet browser You use, unique device identifiers and other diagnostic data.</p>
                    <p>We may also collect information that Your browser sends whenever You visit our Service or when You
                        access the Service by or through a mobile device.</p>
                    <h4>Information Collected while Using the Application</h4>
                    <p>While using Our Application, in order to provide features of Our Application, We may collect, with
                        Your prior permission:</p>
                    <ul>
                        <li>
                            <p>Information regarding your location</p>
                        </li>
                        <li>
                            <p>Pictures and other information from your Device's camera and photo library</p>
                        </li>
                    </ul>
                    <p>We use this information to provide features of Our Service, to improve and customize Our Service. The
                        information may be uploaded to the Company's servers and/or a Service Provider's server or it may be
                        simply stored on Your device.</p>
                    <p>You can enable or disable access to this information at any time, through Your Device settings.</p>
                    <h3>Use of Your Personal Data</h3>
                    <p>The Company may use Personal Data for the following purposes:</p>
                    <ul>
                        <li>
                            <p><strong>To provide and maintain our Service</strong>, including to monitor the usage of our
                                Service.</p>
                        </li>
                        <li>
                            <p><strong>To manage Your Account:</strong> to manage Your registration as a user of the
                                Service. The Personal Data You provide can give You access to different functionalities of
                                the Service that are available to You as a registered user.</p>
                        </li>
                        <li>
                            <p><strong>For the performance of a contract:</strong> the development, compliance and
                                undertaking of the purchase contract for the products, items or services You have purchased
                                or of any other contract with Us through the Service.</p>
                        </li>
                        <li>
                            <p><strong>To contact You:</strong> To contact You by email, telephone calls, SMS, or other
                                equivalent forms of electronic communication, such as a mobile application's push
                                notifications regarding updates or informative communications related to the
                                functionalities, products or contracted services, including the security updates, when
                                necessary or reasonable for their implementation.</p>
                        </li>
                        <li>
                            <p><strong>To provide You</strong> with news, special offers and general information about other
                                goods, services and events which we offer that are similar to those that you have already
                                purchased or enquired about unless You have opted not to receive such information.</p>
                        </li>
                        <li>
                            <p><strong>To manage Your requests:</strong> To attend and manage Your requests to Us.</p>
                        </li>
                        <li>
                            <p><strong>For business transfers:</strong> We may use Your information to evaluate or conduct a
                                merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer
                                of some or all of Our assets, whether as a going concern or as part of bankruptcy,
                                liquidation, or similar proceeding, in which Personal Data held by Us about our Service
                                users is among the assets transferred.</p>
                        </li>
                        <li>
                            <p><strong>For other purposes</strong>: We may use Your information for other purposes, such as
                                data analysis, identifying usage trends, determining the effectiveness of our promotional
                                campaigns and to evaluate and improve our Service, products, services, marketing and your
                                experience.</p>
                        </li>
                    </ul>
                    <p>We may share Your personal information in the following situations:</p>
                    <ul>
                        <li><strong>With Service Providers:</strong> We may share Your personal information with Service
                            Providers to monitor and analyze the use of our Service, to contact You.</li>
                        <li><strong>For business transfers:</strong> We may share or transfer Your personal information in
                            connection with, or during negotiations of, any merger, sale of Company assets, financing, or
                            acquisition of all or a portion of Our business to another company.</li>
                        <li><strong>With Affiliates:</strong> We may share Your information with Our affiliates, in which
                            case we will require those affiliates to honor this Privacy Policy. Affiliates include Our
                            parent company and any other subsidiaries, joint venture partners or other companies that We
                        control or that are under common control with Us.</li>
                    <li><strong>With business partners:</strong> We may share Your information with Our business
                        partners to offer You certain products, services or promotions.</li>
                    <li><strong>With other users:</strong> when You share personal information or otherwise interact in
                        the public areas with other users, such information may be viewed by all users and may be
                        publicly distributed outside.</li>
                    <li><strong>With Your consent</strong>: We may disclose Your personal information for any other
                        purpose with Your consent.</li>
                </ul>
                <h3>Retention of Your Personal Data</h3>
                <p>The Company will retain Your Personal Data only for as long as is necessary for the purposes set out
                    in this Privacy Policy. We will retain and use Your Personal Data to the extent necessary to comply
                    with our legal obligations (for example, if we are required to retain your data to comply with
                    applicable laws), resolve disputes, and enforce our legal agreements and policies.</p>
                <p>The Company will also retain Usage Data for internal analysis purposes. Usage Data is generally
                    retained for a shorter period of time, except when this data is used to strengthen the security or
                    to improve the functionality of Our Service, or We are legally obligated to retain this data for
                    longer time periods.</p>
                <h3>Transfer of Your Personal Data</h3>
                <p>Your information, including Personal Data, is processed at the Company's operating offices and in any
                    other places where the parties involved in the processing are located. It means that this
                    information may be transferred to — and maintained on — computers located outside of Your state,
                    province, country or other governmental jurisdiction where the data protection laws may differ than
                    those from Your jurisdiction.</p>
                <p>Your consent to this Privacy Policy followed by Your submission of such information represents Your
                    agreement to that transfer.</p>
                <p>The Company will take all steps reasonably necessary to ensure that Your data is treated securely and
                    in accordance with this Privacy Policy and no transfer of Your Personal Data will take place to an
                    organization or a country unless there are adequate controls in place including the security of Your
                    data and other personal information.</p>
                <h3>Delete Your Personal Data</h3>
                <p>You have the right to delete or request that We assist in deleting the Personal Data that We have
                    collected about You.</p>
                <p>Our Service may give You the ability to delete certain information about You from within the Service.
                </p>
                <p>You may update, amend, or delete Your information at any time by signing in to Your Account, if you
                    have one, and visiting the account settings section that allows you to manage Your personal
                    information. You may also contact Us to request access to, correct, or delete any personal
                    information that You have provided to Us.</p>
                <p>Please note, however, that We may need to retain certain information when we have a legal obligation
                    or lawful basis to do so.</p>
                <h3>Disclosure of Your Personal Data</h3>
                <h4>Business Transactions</h4>
                <p>If the Company is involved in a merger, acquisition or asset sale, Your Personal Data may be
                    transferred. We will provide notice before Your Personal Data is transferred and becomes subject to
                    a different Privacy Policy.</p>
                <h4>Law enforcement</h4>
                <p>Under certain circumstances, the Company may be required to disclose Your Personal Data if required
                    to do so by law or in response to valid requests by public authorities (e.g. a court or a government
                    agency).</p>
                <h4>Other legal requirements</h4>
                <p>The Company may disclose Your Personal Data in the good faith belief that such action is necessary
                    to:</p>
                <ul>
                    <li>Comply with a legal obligation</li>
                    <li>Protect and defend the rights or property of the Company</li>
                    <li>Prevent or investigate possible wrongdoing in connection with the Service</li>
                    <li>Protect the personal safety of Users of the Service or the public</li>
                    <li>Protect against legal liability</li>
                </ul>
                <h3>Security of Your Personal Data</h3>
                <p>The security of Your Personal Data is important to Us, but remember that no method of transmission
                    over the Internet, or method of electronic storage is 100% secure. While We strive to use
                    commercially acceptable means to protect Your Personal Data, We cannot guarantee its absolute
                    security.</p>
                <h2>Children's Privacy</h2>
                <p>Our Service does not address anyone under the age of 13. We do not knowingly collect personally
                    identifiable information from anyone under the age of 13. If You are a parent or guardian and You
                    are aware that Your child has provided Us with Personal Data, please contact Us. If We become aware
                    that We have collected Personal Data from anyone under the age of 13 without verification of
                    parental consent, We take steps to remove that information from Our servers.</p>
                <p>If We need to rely on consent as a legal basis for processing Your information and Your country
                    requires consent from a parent, We may require Your parent's consent before We collect and use that
                    information.</p>
                <h2>Links to Other Websites</h2>
                <p>Our Service may contain links to other websites that are not operated by Us. If You click on a third
                    party link, You will be directed to that third party's site. We strongly advise You to review the
                    Privacy Policy of every site You visit.</p>
                <p>We have no control over and assume no responsibility for the content, privacy policies or practices
                    of any third party sites or services.</p>
                <h2>Changes to this Privacy Policy</h2>
                <p>We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the
                    new Privacy Policy on this page.</p>
                <p>We will let You know via email and/or a prominent notice on Our Service, prior to the change becoming
                    effective and update the "Last updated" date at the top of this Privacy Policy.</p>
                <p>You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy
                    Policy are effective when they are posted on this page.</p>
                <h2>Contact Us</h2>
                <p>If you have any questions about this Privacy Policy, You can contact us:</p>
                <ul>
                    <li>By email: kuldip.shelke@cerisetechsolutions.com</li>
                </ul>
            </div>
        </div>
    </div>


</div>
</div>
</div>
</template>
<style>
.page {
    width: 100%;
}
.header {
    padding: 16px 0;
}
.container {
    position: relative;
    width: 90%;
    max-width: 1024px;
    margin: 0 auto;
}
.header .title {
    font-size: 40px;
    line-height: 60px;
    font-weight: 700;
    margin: 0;
}
.translations-content-container {
    padding-top: 16px;
    border-top: 1px solid #eee;
}
.container {
    position: relative;
    width: 90%;
    max-width: 1024px;
    margin: 0 auto;
}
.visible {
    display: block;
}
.card {
    background: #fff;
    color: #000;
    font-family: Helvetica Neue,Helvetica,Arial,sans-serif;
    font-size: 16px;
    line-height: 28px;
    align-items: center;
    justify-content: center;
    display: flex;
    margin-top: 10px;
    
}
.flex-container{display: flex;justify-content: space-around;}
h1, h2 {
    font-weight: 700;
}
h1 {
    font-size: 40px;
    line-height: 60px;
}
h1, h2, h3, h4, h5, h6, li, p {
    margin: 0 0 16px;
}
h3, h4 {
    font-weight: 700;
}
p {
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
}
</style>